import * as attribution from "./src/services/attribution-service";
import * as googleAnalyticsService from "./src/services/google-analytics-service";
import * as cookieConsentService from "./src/services/cookie-consent-service";

/**
 * Initial client load — Gatsby wywołuje RAZ, po hydration React'a w przeglądarce.
 *
 * Tu uruchamiamy TYLKO baner cookies (FAK-28914, T1) — od razu przy wejściu, także na localhost.
 * GA4 i attribution NIE startują tutaj: włącza je baner (onAccept), i to wyłącznie po zgodzie.
 * Jeśli zgoda jest już zapisana, baner woła onAccept od razu, więc GA działa zanim odpali onRouteUpdate.
 *
 * Bez wysyłania pageview ani touch — onRouteUpdate w Gatsby v1 ODPALA SIĘ TEŻ przy initial load
 * (dla pierwszej routy), więc gdyby tu je wysłać, dostalibyśmy double-tracking.
 */
exports.onClientEntry = () => {
  cookieConsentService.handleInitializeCookieConsent();
};

/**
 * Każda zmiana routy w SPA navigation — Gatsby wywołuje TEŻ przy initial load
 * (dla pierwszej routy), więc obsługuje zarówno direct visit/refresh jak i klik w <Link>.
 *
 * Gatsby 1.9 woła: onRouteUpdate({ location, action }, pluginOptions)
 * (node_modules/gatsby/cache-dir/production-app.js), więc state.location.pathname to nowa ścieżka.
 * Parametry page i pages nie istnieją — w v1 drugi argument to opcje pluginu.
 *
 * Obie funkcje same sprawdzają localhost i zgodę z banera — bez zgody nic nie wysyłają.
 */
exports.onRouteUpdate = (state, page, pages) => {
  /** TRACKING PAGEVIEWS — GA4 */
  googleAnalyticsService.trackPageview(state.location.pathname);

  /** ATTRIBUTION TOUCH */
  // Każda strona to potencjalny conversion path — touch leci do n8n.
  // session_id pozostaje ten sam (z cookie), więc backend wie że to ten sam user.
  attribution.touch(state.location.pathname);
};



// WEBPACK FOOTER //
// ./gatsby-browser.js